import { I18n } from '@calendly/i18n';
import { Control, Option, Options, Select } from '@calendly/ui/components/select';
import { SelectField } from '@calendly/ui/form/select-field';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useNewDropdownSelector } from '../selectors';
import { useStateValue } from '../state_provider';
import { OptionBody } from './option_body';

// i18n-tasks-use t("publisher.event_type_editor.sections.event_details.fields.location.dropdown.dividers.web_conferencing")
const dividerCss = "d1aj8wu";
const Divider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    value,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dividerCss, props.className)}>
      {I18n.t(`publisher.event_type_editor.sections.event_details.fields.location.dropdown.dividers.${value}`)}
    </Component>;
});
const UpdatedSelect = ({
  onChange,
  kind,
  isDisabled = false,
  availableKinds,
  placeholder,
  ...props
}) => <Select value={kind} onChange={onChange} disabled={isDisabled}>
    <Control placeholder={placeholder} {...props}>
      {kind && <OptionBody value={kind} />}
    </Control>
    <Options>
      {availableKinds.map(({
      type,
      value
    }) => {
      if (type === 'divider') {
        return <Divider key={value} value={value} />;
      }
      return <Option key={value} value={value}><OptionBody value={value} /></Option>;
    })}
    </Options>
  </Select>;
export const LocationSelect = ({
  onChange,
  kind,
  isDisabled = false,
  availableKinds,
  ...props
}) => {
  const state = useStateValue();
  const useNewDropdown = useNewDropdownSelector(state);
  if (useNewDropdown) {
    return <UpdatedSelect {...props} disabled={isDisabled} placeholder={I18n.t('publisher.event_types.location.placeholder')} availableKinds={availableKinds} kind={kind} onChange={onChange} />;
  }
  return <SelectField {...props} disabled={isDisabled} placeholder={I18n.t('publisher.event_types.location.placeholder')} value={kind} onChange={onChange} options={availableKinds.map(value => ({
    value,
    name: <OptionBody value={value} />
  }))} />;
};

require("./location_select.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location_select.js");